import React, { Component } from 'react';
import { WithStyles } from 'decorators/withStyles';
import { IUser } from 'interface/user';
import { removeComment, edit, nextPage } from 'actionCreators/forum';
import { connect } from 'react-redux';
import { IComment } from '../../../../interface/forum';
import CommentItem from '../CommentItem';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { WithRouter } from 'decorators/withRouter';

interface IState {
  open?: boolean;
  anchorEl?: any;
}

interface IProps {
  comments: IComment;
  user: IUser;
  classes: any;
  nextPage: typeof nextPage;
  history?: any;
}

@WithStyles({
  noPadding: {
    padding: 0
  },
  tableFooter: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
})
@WithRouter()
class TableComments extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { open: false };
  }

  handleFirstPageButtonClick = () => {
    this.changeUrl(this.props.comments.first_page_url);
    this.props.nextPage(this.props.comments.first_page_url, 'first_page');
  };

  handleBackPageButtonClick = () => {
    this.changeUrl(this.props.comments.prev_page_url);
    this.props.nextPage(this.props.comments.prev_page_url, 'prev_page');
  };

  handleNextPageButtonClick = () => {
    this.changeUrl(this.props.comments.next_page_url);
    this.props.nextPage(this.props.comments.next_page_url, 'next_page');
  };

  handleLastPageButtonClick = () => {
    this.changeUrl(this.props.comments.last_page_url);
    this.props.nextPage(this.props.comments.last_page_url, 'last_page');
  };

  changeUrl = (newPageUrl: string) => {
    const newPage = newPageUrl.split('?')[1];
    const contentId = this.props.history.location.search.split('&')[1];
    this.props.history.replace({ search: `?${newPage}&${contentId}` });
  };

  render() {
    const { comments, user, classes } = this.props;
    if (!this.props.comments) return null;
    const { total, from, to } = comments;
    return (
      <div>
        <div className={classes.tableWrapper}>
          {comments.data.map(comment => (
            <CommentItem comment={comment} key={comment.id} user={user} />
          ))}
          <div className={classes.tableFooter}>
            <div>
              {from || 0} - {to || 0} de {total}
            </div>
            <div>
              <IconButton
                onClick={this.handleFirstPageButtonClick}
                disabled={from <= 1 || !from}
                aria-label="first page"
              >
                <FirstPageIcon />
              </IconButton>

              <IconButton onClick={this.handleBackPageButtonClick} disabled={from <= 1 || !from} aria-label="back-page">
                <KeyboardArrowLeft />
              </IconButton>

              <IconButton
                onClick={this.handleNextPageButtonClick}
                disabled={to === total || !to}
                aria-label="next-page"
              >
                <KeyboardArrowRight />
              </IconButton>

              <IconButton
                onClick={this.handleLastPageButtonClick}
                disabled={to === total || !to}
                aria-label="last page"
              >
                <LastPageIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    user: state.user
  };
};
export default connect(mapStateToProps, { removeComment, edit, nextPage })(TableComments);
